import React, {Component} from 'react';
import { InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Form, FormGroup,  FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/Videocam';
import NavigationIcon from '@material-ui/icons/Navigation';
import { Badge } from 'material-ui';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipNextIcon from '@material-ui/icons/SkipNext';




const styles = theme => ({
    card: {
      display: 'flex',
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      flex: '1 0 auto',
    },
    cover: {
      width: 200,
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
    },
    playIcon: {
      height: 38,
      width: 38,
    },
  });



class VisualClipComponent extends Component {
  constructor(props) {
    super(props);

}



	
  sendData(e){

	 this.toggle();
  }
  

  mediaControlCard(props, clip) {
    const { classes, theme } = props;
    //const { player } = this.refs.player.play()
    return (
      <Card className={classes.card}>
        { /*
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography component="h5" variant="h5">
              {clip.title}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {clip.subtitle}
            </Typography>
          </CardContent>

        </div>
        */}
        <Player playsInline autoPlay src={clip.video.videoLow} muted={true} type="video/mp4" >
          <BigPlayButton position="center" />
          </Player>

      </Card>
    );
  }

  render() {
	  	  	  	  
    const { classes } = this.props;
	// prop clips holds an array of objects, where the object is a clip containing all clip information like id, etc. 
    return (
      <div>
       {
           this.props.clips.length > 0 ? this.props.clips.map( clip => (                              
              console.log('videoclipcomponent: ', clip), 
               this.mediaControlCard(this.props, clip)
           )
        
           ) : null
       }
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(VisualClipComponent);




// WEBPACK FOOTER //
// ./src/modules/movie-browser/VisualClipComponent.js